import { APIClient } from "./APIClient"

export const SchakoAPIClient = new APIClient({
  audience: import.meta.env.VITE_API_AUDIENCE
})
